<script setup lang="ts">
import { useField } from 'vee-validate';
import { computed, type WritableComputedRef } from 'vue';
import { format, parseISO, parse, isValid } from 'date-fns';
import type { Locales } from '@/services/types/api.types';

const props = defineProps<{
  name: string;
  label: string;
  editLocale?: Locales;
}>();

const { value: fieldValue, errorMessage } = useField<string>(props.name);

const dateValue: WritableComputedRef<string | number | null> = computed({
  get() {
    if (typeof fieldValue.value === 'string' && fieldValue.value.trim() !== '') {
      const date = parseISO(fieldValue.value);
      return isValid(date) ? format(date, 'yyyy/MM/dd') : '';
    }
    return '';
  },
  set(value) {
    if (typeof value === 'string' && value.trim() !== '') {
      const date = parse(value, 'yyyy/MM/dd', new Date());
      if (isValid(date)) {
        fieldValue.value = date.toISOString();
      }
    } else {
      fieldValue.value = null;
    }
  },
});
</script>

<template>
  <q-input
    outlined
    v-model="dateValue"
    :label="props.label"
    v-bind="$attrs"
    clearable
    :error="!!errorMessage"
    :error-message="errorMessage"
  >
    <template v-slot:append>
      <q-icon name="event" class="cursor-pointer">
        <q-popup-proxy cover transition-show="scale" transition-hide="scale">
          <q-date v-model="dateValue" mask="YYYY/MM/DD">
            <div class="row items-center justify-end">
              <q-btn v-close-popup label="Close" color="primary" flat />
            </div>
          </q-date>
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>
